<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('animales')">Animales</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Bitácora
      <span class="text-gray-500 text-base font-normal ml-2">
        ({{ animal.arete }} - {{ animal.nombre }})
      </span>
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden">
      <div class="p-6 border-b">
        <div class="font-bold text-lg">
          {{ animal.nombre || 'Sin nombre' }}
          <span class="text-gray-500 font-normal">({{ animal.arete || '-' }})</span>
        </div>
        <div class="text-sm text-gray-600 mt-1">
          Código: <span class="font-medium">{{ animal.codigo || '-' }}</span>
          <span class="mx-2">|</span>
          Especie: <span class="font-medium">{{ animal.especie || '-' }}</span>
          <span class="mx-2">|</span>
          Raza: <span class="font-medium">{{ animal.raza || '-' }}</span>
          <span class="mx-2">|</span>
          Estado: <span class="font-medium">{{ animal.estado || '-' }}</span>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-bold">
              <th class="px-6 pt-6 pb-4">Fecha</th>
              <th class="px-6 pt-6 pb-4">Tipo</th>
              <th class="px-6 pt-6 pb-4">Título</th>
              <th class="px-6 pt-6 pb-4">Detalle</th>
              <th class="px-6 pt-6 pb-4">Observación</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(b, i) in bitacora"
              :key="i"
              class="hover:bg-gray-100 focus-within:bg-gray-100"
            >
              <td class="border-t px-6 py-4">{{ b.fecha || '-' }}</td>
              <td class="border-t px-6 py-4">{{ b.tipo || '-' }}</td>
              <td class="border-t px-6 py-4">{{ b.titulo || '-' }}</td>
              <td class="border-t px-6 py-4">{{ b.detalle || '-' }}</td>
              <td class="border-t px-6 py-4">{{ b.obs || '-' }}</td>
            </tr>

            <tr v-if="!bitacora || bitacora.length === 0">
              <td class="border-t px-6 py-4" colspan="5">
                No hay registros en la bitácora.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="px-6 py-4 bg-gray-50 border-t border-gray-100">
        <inertia-link class="text-indigo-500 hover:text-indigo-700" :href="route('animales.edit', animal.id)">
          ← Volver a la ficha del animal
        </inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  layout: Layout,
  props: {
    animal: Object,
    bitacora: Array,
  },
}
</script>